import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import InviteCustomer from "../constant/ModalList";
import EmployeeOffcanvas from "../constant/EmployeeOffcanvas";
import Layout from "../components/layouts/Layout";
import MainPagetitle from "../components/layouts/MainPagetitle";
import { useDispatch, useSelector } from "react-redux";
import { deleteRooms, getAllUsers, getPublicRooms } from "../../store/actions/AdminAction";
import moment from "moment";
import Search from "../components/elements/Search";
import Placholder from "../../images/placholder-img-admin1.png";
import CreatePublicRoomModal from "../components/modals/CreatePublicRoomModal";
import { Button, Modal } from "react-bootstrap";

const PublicRooms = () => {
  const IMG_URL = process.env.REACT_APP_FILE_BASE_URL + "/";
  const limit = 7;
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState();
  const [editData, setEditData] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const rooms = useSelector((state) => state?.adminReducer?.publicRooms);
  const totalRooms = useSelector((state) => state?.adminReducer?.totalRooms);
  const lastIndex = page * limit;
  const npage = Math.ceil(totalRooms / limit);
  const number = npage ? [...Array(npage + 1).keys()].slice(1) : [1];
  const [viewVal, setViewVal] = useState(false);
  const [roomsIdToDelete, setRoomsIdToDelete] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(getPublicRooms(page, limit, search));
  }, [page, limit, search]);

  function prePage() {
    if (page !== 1) {
      setPage(page - 1);
    }
  }
  function changeCPage(id) {
    setPage(id);
  }
  function nextPage() {
    if (page !== npage) {
      setPage(page + 1);
    }
  }

  const invite = useRef();
  const employe = useRef();

  const handleDelete = (id) => {
    setRoomsIdToDelete(id);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    try {
      await dispatch(deleteRooms(roomsIdToDelete));
      setShowModal(false);
      setRoomsIdToDelete(null);
      getPublicRooms(page, limit);
    } catch (error) {
      console.error('Deletion failed:', error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setRoomsIdToDelete(null);
  };



  return (
    <Layout>
      <MainPagetitle
        mainTitle="Public Rooms"
        pageTitle={"Public Rooms"}
        parentTitle={"Home"}
      />

      <CreatePublicRoomModal viewVal={viewVal} setViewVal={setViewVal} editData={editData} setEditData={setEditData} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                    <h4 className="heading mb-0">Public Rooms</h4>
                    <div className="srearch-btn">
                      <div className="tbl-caption d-flex justify-content-end text-wrap align-items-center pl-0-btn">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            setEditData({})
                            setViewVal(true)
                          }}
                        >
                          Create Room
                        </button>
                        <div className="searchbarpublic">
                          <Search setSearch={setSearch} setPage={setPage} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer h-fixed-505"
                  >
                    <table
                      id="empoloyees-tblwrapper"
                      className="table ItemsCheckboxSec dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Room Name</th>
                          <th>Room Type</th>
                          <th>Category</th>
                          <th>Members</th>
                          <th>Description</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rooms?.length > 0 ? (
                          rooms?.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <span>{index + lastIndex - limit + 1}</span>
                              </td>
                              <td>
                                <div className="products">
                                  {/* <img
                                  src={
                                    item?.profile_image
                                      ? IMG_URL + item?.profile_image
                                      : Placholder
                                  }
                                  className="avatar avatar-md"
                                  alt=""
                                /> */}
                                  <div
                                  // className="pointerUser"
                                  // onClick={() =>
                                  //   navigate(`/user-detail/${item._id}`)
                                  // }
                                  >
                                    <h6>{item?.roomname}</h6>
                                    {/* <span>Customer</span> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="text-primary ">
                                  {item?.roomtype.roomtype}
                                </span>
                              </td>
                              <td>
                                <span className="td-text-wrap">
                                  {item?.roomcategory
                                    ?.map((ob) => ob.roomcategory)
                                    .join(", ")}
                                </span>
                              </td>
                              <td>
                                <span>{item?.members?.length}</span>
                              </td>
                              <td>
                                <span>{item?.description}</span>
                              </td>
                              {/* <td>
                              <span
                                className={`badge light border-0 ${
                                  item.status === 1
                                    ? "badge-success"
                                    : "badge-danger"
                                } `}
                              >
                                {item.status === 1 ? "Active" : "In-active"}
                              </span>
                            </td> */}

                              <td>
                                <div className="d-flex justify-content-between gap-2">
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => {
                                      setEditData(item);
                                      setViewVal(true);
                                    }}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleDelete(item?._id)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>


                            </tr>
                          ))
                        ) : (
                          <td colspan="10">
                            <p className="no_content_table">No Public Rooms</p>
                          </td>
                        )}



                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <div className="dataTables_info">
                        Showing {totalRooms == 0 ? 0 : lastIndex - limit + 1} to{" "}
                        {totalRooms < lastIndex ? totalRooms : lastIndex} of{" "}
                        {totalRooms} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers justify-content-center"
                        id="example2_paginate"
                      >
                        <Link
                          className="paginate_button previous disabled"
                          to="#"
                          onClick={prePage}
                        >
                          <i className="fa-solid fa-angle-left" />
                        </Link>
                        <span>
                          {number.map((n, i) => (
                            <Link
                              className={`paginate_button ${page === n ? "current" : ""
                                } `}
                              key={i}
                              onClick={() => changeCPage(n)}
                            >
                              {n}
                            </Link>
                          ))}
                        </span>
                        <Link
                          className="paginate_button next"
                          to="#"
                          onClick={nextPage}
                        >
                          <i className="fa-solid fa-angle-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmployeeOffcanvas ref={employe} Title="Add Employee" />
      <InviteCustomer ref={invite} Title="Invite Employee" />

      {/* Delete Confirmation Modal */}
      <Modal show={showModal} onHide={closeModal} >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            No
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>


    </Layout>
  );
};

export default PublicRooms;
